import JsonLd from "@/components/JsonLd.tsx";
import JsonLdBreadcrumbList from "@/components/JsonLdBreadcrumbList.tsx";
import {config} from "@/config/config.ts";
import CommunitiesPage, {COMMUNITY_FAQS} from "@/pages/communities/CommunitiesPage.tsx";
import {createFileRoute} from '@tanstack/react-router'

// Public marketing page for community organisers. Not /communities/: that path is the signed-in
// Communities List (routes/_app/communities), so this follows /for-players/ instead.
export const Route = createFileRoute('/for-communities')({
    component: RouteComponent,
})

const TITLE = "Community Sports Management Software | ScorePal";
const DESCRIPTION = "Run your sports community with ScorePal: WhatsApp sessions, player CRM, card payments, leagues, tournaments, scheduling and live scores in one place.";

function RouteComponent() {
    const url = `${config.publicUrl}/for-communities/`;

    return <>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="ScorePal" />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content="Bring your WhatsApp sessions, players, payments, leagues and tournaments into one professional home." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={`${config.publicUrl}/og-image.png`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content="WhatsApp sessions, payments, player CRM, leagues and live scores for sports communities." />
        <meta name="twitter:image" content={`${config.publicUrl}/og-image.png`} />

        <JsonLd id={`page${Route.id}/app`} item={{
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "ScorePal for Communities",
            "applicationCategory": "SportsApplication",
            "operatingSystem": "Web, iOS, Android",
            "description": DESCRIPTION,
            "url": "https://scorepal.co/for-communities/",
            "publisher": {"@type": "Organization", "name": "ScorePal"},
        }} />
        <JsonLd id={`page${Route.id}/faq-schema`} item={{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": COMMUNITY_FAQS.map((f) => ({
                "@type": "Question",
                "name": f.q,
                "acceptedAnswer": {"@type": "Answer", "text": f.a},
            })),
        }} />
        <JsonLdBreadcrumbList routeId={Route.id} crumbs={[{name: "For Communities", item: "https://scorepal.co/for-communities/"}]} />

        <CommunitiesPage />
    </>
}
